import { computed, makeObservable } from 'mobx'

import { type IDefaultShift } from 'modules/shift_management/store/api/models/DefaultShift'

import DefaultShift, {
  TDefaultShift,
} from 'modules/shift_management/store/internal/models/DefaultShift'

class DefaultShifts {
  defaultShifts: DefaultShift[]

  constructor(defaultShifts: DefaultShift[]) {
    this.defaultShifts = defaultShifts.sort((a, b) => {
      return a.title.localeCompare(b.title)
    })

    makeObservable(this, {
      defaultShiftIds: computed,
      all: computed,
      active: computed,
    })
  }

  /**
   * Transforms an array of objects from a request into an array of DefaultShift
   * objects
   */
  /**
   * @deprecated Before using this method, consider using the `buildFromGraphQL` hook since
   * we are trying to move away from using mobx-rest and use GraphQL instead.
   */
  static buildFromProps(defaultShifts: IDefaultShift[]): DefaultShifts {
    const defaultShiftObjects = defaultShifts.map((defaultShift) => {
      return DefaultShift.buildFromProps(defaultShift)
    })

    return new DefaultShifts(defaultShiftObjects)
  }

  static buildFromGraphQL(defaultShifts: TDefaultShift[]): DefaultShifts {
    const defaultShiftObjects = defaultShifts.map((defaultShift) => {
      return DefaultShift.buildFromGraphQL(defaultShift)
    })

    return new DefaultShifts(defaultShiftObjects)
  }

  get defaultShiftIds(): string[] {
    return this.defaultShifts.map((defaultShift) => defaultShift.id)
  }

  get all(): DefaultShift[] {
    return this.defaultShifts
  }

  get active(): DefaultShift[] {
    return this.defaultShifts.filter((defaultShift) => !defaultShift.archived)
  }
}

export default DefaultShifts
